export enum BaseRoute {
  HOME = "/",
  SCHEDULE = "/schedule",
  PROFILE = "/profile",
  AUTH = "/auth",
  DOCUMENTS = "/documents",
  HELP = "/help",
  SPONSOR = "/sponsor",
  HACKER = "/hacker",
  PLAYGROUND = "/playground",
  NOT_FOUND = "/404",
  MENTOR = "/mentor",
}

export enum DocumentRoute {
  CODE_OF_CONDUCT = "code-of-conduct",
  PRIVACY_POLICY = "privacy-policy",
  TERMS_AND_CONDITIONS = "terms-and-conditions",
}

export enum SponsorRoute {
  PERKS = "perks",
  PROFILE = "profile",
  REPRESENTATIVES = "representatives",
  RECRUITMENT = "recruitment",
  PLATFORM_ONBOARDING = "platform-onboarding",
}

export enum HackerRoute {
  RSVP = "rsvp",
  PERSONAL = "personal",
  EVENT = "event",
  CAREER = "career",
  MENTORSHIP = "mentorship",
  BADGES = "badges",
  GETTING_STARTED = "getting-started",
  WORKSHOPS = "workshops",
  JUDGING = "judging",
  COMMUNITY = "community",
  FAQ = "faq",
}

export enum MentorRoute {
  REQUESTS = "requests",
  CLAIMED_REQUESTS = "claimed-requests",
  PROFILE = "profile",
}

// includes all valid routes
// Not allowed to be an enum for now :(( https://github.com/microsoft/TypeScript/issues/40793
export const Route = {
  HOME: BaseRoute.HOME,
  SCHEDULE: BaseRoute.SCHEDULE,
  PROFILE: BaseRoute.PROFILE,
  AUTH: BaseRoute.AUTH,
  DOC_COC: `${BaseRoute.DOCUMENTS}/${DocumentRoute.CODE_OF_CONDUCT}`,
  DOC_TAC: `${BaseRoute.DOCUMENTS}/${DocumentRoute.TERMS_AND_CONDITIONS}`,
  DOC_PRIVACY: `${BaseRoute.DOCUMENTS}/${DocumentRoute.PRIVACY_POLICY}`,
  HELP: BaseRoute.HELP,

  SPONSOR_PERKS: `${BaseRoute.SPONSOR}/${SponsorRoute.PERKS}`,
  SPONSOR_REPRESENTATIVES: `${BaseRoute.SPONSOR}/${SponsorRoute.REPRESENTATIVES}`,
  SPONSOR_RECRUITMENT: `${BaseRoute.SPONSOR}/${SponsorRoute.RECRUITMENT}`,
  SPONSOR_PROFILE: `${BaseRoute.SPONSOR}/${SponsorRoute.PROFILE}`,
  SPONSOR_PLATFORM_ONBOARDING: `${BaseRoute.SPONSOR}/${SponsorRoute.PLATFORM_ONBOARDING}`,

  MENTOR_REQUESTS: `${BaseRoute.MENTOR}/${MentorRoute.REQUESTS}`,
  MENTOR_CLAIMED_REQUESTS: `${BaseRoute.MENTOR}/${MentorRoute.CLAIMED_REQUESTS}`,
  MENTOR_PROFILE: `${BaseRoute.MENTOR}/${MentorRoute.PROFILE}`,

  HACKER_RSVP: `${BaseRoute.HACKER}/${HackerRoute.RSVP}`,
  HACKER_PERSONAL: `${BaseRoute.HACKER}/${HackerRoute.PERSONAL}`,
  HACKER_EVENT: `${BaseRoute.HACKER}/${HackerRoute.EVENT}`,
  HACKER_CAREER: `${BaseRoute.HACKER}/${HackerRoute.CAREER}`,

  HACKER_MENTORSHIP: `${BaseRoute.HACKER}/${HackerRoute.MENTORSHIP}`,

  HACKER_BADGES: `${BaseRoute.HACKER}/${HackerRoute.BADGES}`,

  HACKER_GETTING_STARTED: `${BaseRoute.HACKER}/${HackerRoute.GETTING_STARTED}`,
  HACKER_WORKSHOPS: `${BaseRoute.HACKER}/${HackerRoute.WORKSHOPS}`,
  HACKER_JUDGING: `${BaseRoute.HACKER}/${HackerRoute.JUDGING}`,
  HACKER_COMMUNITY: `${BaseRoute.HACKER}/${HackerRoute.COMMUNITY}`,
  HACKER_FAQ: `${BaseRoute.HACKER}/${HackerRoute.FAQ}`,

  PLAYGROUND: BaseRoute.PLAYGROUND,
  NOT_FOUND: BaseRoute.NOT_FOUND,
};
